import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, setApiKeyToObject } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const CustomerJobGroupPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getCustomerJobGroupsAsPublic", "customerIdHash", customerIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/job-groups`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getCustomerJobGroupsAsPublic",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const CustomerJobGroupPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = CustomerJobGroupPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getCustomerJobGroupsAsPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const CustomerJobGroupPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = CustomerJobGroupPublicControllerApiFp(configuration);
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic(requestParameters, options) {
      return localVarFp.getCustomerJobGroupsAsPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class CustomerJobGroupPublicControllerApi extends BaseAPI {
  /**
   * 고객사의 직군 리스트 퍼블릭 조회
   * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerJobGroupPublicControllerApi
   */
  getCustomerJobGroupsAsPublic(requestParameters, options) {
    return CustomerJobGroupPublicControllerApiFp(this.configuration).getCustomerJobGroupsAsPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getCustomerJobGroupsAsPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: CustomerJobGroupPublicControllerApiAxiosParamCreator().getCustomerJobGroupsAsPublic,
  requestFn: CustomerJobGroupPublicControllerApiFp().getCustomerJobGroupsAsPublic
});

export { CustomerJobGroupPublicControllerApi, CustomerJobGroupPublicControllerApiAxiosParamCreator, CustomerJobGroupPublicControllerApiFactory, CustomerJobGroupPublicControllerApiFp, getCustomerJobGroupsAsPublicRemote };
//# sourceMappingURL=customer-job-group-public-controller-api.mjs.map
